module.exports = __webpack_public_path__ + "static/media/Ke hoach quy hoach su dung dat.90e53a96.png";